import Utils from "../../../../../../../shared/utils";

export const EDIT_ICON = Utils.buildNewsletterLink("icons/edit.svg");